<template>
  <div class="card mg-b-20">
    <div class="card-header d-flex align-items-center justify-content-between">
      <h6 class="mg-b-0">
        {{ box != undefined && box.nm != undefined ? box.nm : "" }}
      </h6>
    </div>
    <ul class="list-group list-group-flush">
      <li
        class="list-group-item list-group-item-action d-flex align-items-center justify-content-between bd-0"
        v-for="(f, i) in forms"
        :key="i"
        role="button"
      >
        <div :class="`${f.flag == 700 ? 'wd-60p' : 'wd-100p'} d-flex`">
          <!-- <div class="avatar">
            <router-link :to="backTo=='lesson'?            
              {name: 'lmsLessonView', params: { id: $route.params.id, cid: $route.params.cid, bid: box.id, iid: f.id, bot: box.ot, }}:
              {name: 'lmsCourseView', params: { id: $route.params.id, bid: box.id, iid: f.id, bot: box.ot, }}
            ">
              <span :class="`avatar-initial rounded-circle bg-transparent bd bd-gray-900`">
                <feather type="pen-tool" class="tx-color-02" style="margin-top: -4px; width: 19px; height: 19px;"></feather>
              </span>
            </router-link>
          </div> -->
          <div class="avatar d-none d-sm-block">
            <span :class="`avatar-initial rounded-circle bg-teal`">
              <i class="icon ion-md-trophy"></i>
            </span>
          </div>
          <div class="pd-l-10  wd-80p">
            <template v-if="fillOnModal">
              <a @click="$emit('on-modal-form-fill', {id: f.id, bid: box.id, bot: box.ot, prms: f })">
                <h6 class="tx-14 tx-semibold mg-b-5">{{ f.nm }}</h6>
              </a>
            </template>
            <template v-else-if="backTo == 'courseHome'">
              <router-link
                :to="{
                  name: 'lmsLessonView',
                  params: {
                    id: lid,
                    cid: course.id,
                    bid: box.id,
                    iid: f.id,
                    bot: box.ot
                  }
                }"
              >
                <h6 class="tx-14 tx-semibold mg-b-5">{{ f.nm }}</h6>
                <span class="d-block tx-11 text-muted"
                  >нийт {{ f.qCount }} асуулт.
                  <span v-if="f.flag != 900"
                    >Бөглөсөн {{ f.fillingCount }}.
                  </span>
                  <span v-if="f.flag == 500 || f.flag == 800"
                    >Бүрэн дуусгасан {{ f.attemptCount }}</span
                  >
                  <span v-if="f.flag == 900"
                    >Хугацаа: {{ f.sd | moment("YYYY.MM.DD (HH:mm") }} -
                    {{ f.ed | moment("HH:mm)") }}</span
                  >
                </span>
              </router-link>
            </template>
            <template v-else>
              <router-link
                :to="
                  backTo == 'lesson'
                    ? {
                        name: 'lmsLessonView',
                        params: {
                          id: $route.params.id,
                          cid: $route.params.cid,
                          bid: box.id,
                          iid: f.id,
                          bot: box.ot
                        }
                      }
                    : {
                        name: 'lmsCourseView',
                        params: {
                          id: $route.params.id,
                          bid: box.id,
                          iid: f.id,
                          bot: box.ot
                        }
                      }
                "
              >
                <h6 class="tx-14 tx-semibold mg-b-5">{{ f.nm }}</h6>
                <span class="d-block tx-11 text-muted"
                  >нийт {{ f.qCount }} асуулт.
                  <span v-if="f.flag != 900"
                    >Бөглөсөн {{ f.fillingCount }}.
                  </span>
                  <span v-if="f.flag == 500 || f.flag == 800"
                    >Бүрэн дуусгасан {{ f.attemptCount }}</span
                  >
                  <span v-if="f.flag == 900"
                    >Хугацаа: {{ f.sd | moment("YYYY.MM.DD (HH:mm") }} -
                    {{ f.ed | moment("HH:mm)") }}</span
                  >
                </span>
              </router-link>
            </template>
          </div>
        </div>
        <div class="progress ht-15 wd-40p" v-if="f.flag == 700">
          <div
            role="progressbar"
            class="progress-bar bg-secondary"
            :style="{ width: (f.fillingCount * 100) / f.qCount + '%' }"
          >
            <span class="tx-9"
              >{{ ((f.fillingCount * 100) / f.qCount).toFixed(2) }}%</span
            >
          </div>
        </div>
        <button
          v-else-if="f.flag == 900 && examHasEnded(f)"
          @click="$emit('on-show-exam-result', f.id)"
          class="btn btn-xs btn-outline-light wd-100"
        >
          Дүн харах
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
const moment = require("moment");

export default {
  props: {
    box: {
      type: Object,
      default: () => {}
    },
    forms: {
      type: Array,
      default: () => []
    },
    course: {
      type: Object,
      default: () => {}
    },
    backTo: {
      type: String,
      default: () => "lesson"
    },
    lid: {
      type: Number,
      default: () => 0
    },
    fillOnModal: {
      type: Boolean,
      default: () => false
    },
  },
  methods: {
    examHasEnded(f) {
      //console.log(this.course.date.now, f.ed);
      if (moment(f.ed).isBefore(moment(this.course.date.now))) {
        return true;
      } else return false;
      //console.log(f);
    }
  }
};
</script>

<style></style>
